<header class="topnavbar-wrapper" [attr.aria-label]="bs.getResource('rbkey_NvBrClntLgLBL')" tabindex="0">
    <nav role="navigation" class="navbar navbar-expand-sm topnavbar" style="margin: 0; padding:0;">
        <div id="mainHeader" class="main-header-container d-flex justify-content-between">
            <div class="navbar-header">
                <a href="javascript:void(0);" class="navbar-brand">
                    <div class="brand-logo">
                        <img src="{{bs.getUserAttr('ClientLogo')}}" alt="{{bs.getResource('rbkey_NvBrClntLgLBL')}}"
                            class="img-responsive cursor-default">
                    </div>
                    <div class="brand-logo-collapsed">
                        <img src="{{bs.getUserAttr('ClientLogo')}}" alt="{{bs.getResource('rbkey_NvBrClntLgLBL')}}"
                            class="img-responsive cursor-default">
                    </div>
                </a>
            </div>
            <div [ngClass]="menuCollapse" style="justify-content: space-between;">
                <button (click)="expandMenu()" type="button" class="navbar-toggler">
                    <span class="sr-only">{{bs.getResource('rbkey_TgglNvgtn')}}</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
            
            <!-- <div class="collapse navbar-collapse" id="toggleid"> -->
                
                <ul class="nav navbar-nav left-nav">
                    <li *ngFor="let item of bs.menu['MenuItems']">
                        <a (click)="loadSubMenu(item)" href="javascript:void(0);"
                            class="menu {{item.isQuickLinkActive ? 'active' : ''}}">
                            {{bs.getResource(item.Key)}}
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/checkpoint/enterprise/login/117769028?application=learning&appInstanceId=132879964&authModeId=7229058792930336768" target="_blank">
                            <img src="assets/img/LinkedIn.png" alt="LinkedIn Logo" style="width:133px;">
                        </a>
                    </li>
                    <li>
                        <a href="https://thriversity-api.harappa.education/learner/sso/login?RelayState=68494cfe201579225596c8bc" target="_blank">
                            <img src="assets/img/Upgrad.jpg" alt="UpGrad Logo" style="width: 80px; height: 35px;">
                        </a>
                    </li>
                </ul>
            <!-- </div> -->

                <!-- <app-fontbox *ngIf="bs.getUserAttr('EnableFntBox')=='TRUE'"></app-fontbox>
                <ul *ngIf="bs.getUserAttr('EnableLngBox')=='TRUE'" class="nav navbar-nav left-nav collapse" (click)="openlang($event, 'language')">
                    <li>
                        <a href="#" id="language">
                            <span>
                                <span id="langtext" class="langtrans">{{currentLang}}</span>&nbsp;&nbsp;
                                <em class="fa fa-angle-down"></em>
                            </span>
                        </a>
                        <ul class="dropdown-menu lang" data-toggle="dropdown">
                            <li id="cultureId" (click)="setCulture(culture['mstrCultureId'])" *ngFor="let culture of bs.getUserAttr('CultureList');">
                                <a class="{{culture['mstrCultureId']==bs.getUserAttr('Culture') ? 'activeRole' : ''}}">{{culture['mstrCultureId'].slice(0,2)}} - {{culture['mstrCultureName'] }}</a>
                            </li>
                        </ul>
                    </li>
                </ul> -->
                <ul style="border-left: 1px solid #ff9292; min-width: 390px!important;display: flex;" class="nav navbar-nav navbar-right">
                    <app-fontbox *ngIf="bs.getUserAttr('EnableFntBox')=='TRUE'" aria-hidden="true"></app-fontbox>

                    <li *ngIf="bs.getUserAttr('EnableLngBox')=='TRUE'" style="border-left: none;padding: 15px;" class="dropdown">
                        <a href="javascript:void(0);" data-toggle="dropdown"
                            id="language" [attr.aria-label]="bs.getResource('rbkey_LnggClnLBL')" aria-expanded="false">
                            <span>
                                <span id="langtext" class="langtrans fontBox-a"
                                    title={{currentLang}}>{{currentLang}}</span>
                                <em class="fa fa-angle-down"></em>
                            </span>
                        </a>
                        <ul id="langDropDown" class="dropdown-menu" (click)="openlang($event, 'language')"style="left: auto;">

                            <li id="cultureId" (click)="setCulture(culture['mstrCultureId'])"
                                *ngFor="let culture of CultureList;">
                                <a class="{{culture['mstrCultureId']==bs.getUserAttr('Culture') ? 'activeRole' : ''}}"style="display: block;">{{culture['mstrCultureId'].slice(0,2)}}
                                    - {{culture['mstrCultureName'] }}</a>
                            </li>
                        </ul>
                    </li>
                    <li style="display: inline-flex;" class="dropdown">
                        <a href="javascript:void(0);" style="padding: 15px;" data-toggle="dropdown"
                            aria-expanded="false">
                            <div class="user-block-picture display-inline margin_right5">
                                <div class="user-block-status">
                                    <img src={{bs.userProfileImage}} alt="{{bs.getResource('rbkey_NvBrUsrImgLBL')}}"
                                        style="font-size:3px;" width="30" height="30" class="img-thumbnail img-circle"
                                        title="{{bs.getResource('rbkey_NvBrUsrImgLBL')}}">
                                </div>
                            </div>
                            <span>
                                <!-- {{userName}} -->
                                <em class="fa fa-angle-down"></em>
                            </span>
                        </a>
                        <ul (click)="openSubMenu($event,'profileMenu')" id="profileMenu" class="dropdown-menu" style="left: auto;">
                            <li>
                                <a href="javascript:void(0);" (click)="RedirectUserProfile(null)"style="display: block;">
                                    <i class="fa fa-user"
                                        aria-hidden="true"></i>&nbsp;{{bs.getResource('rbkey_PrflLBL')}}</a>
                            </li>
                            <li class="dropdown-submenu">
                                <a href="javascript:void(0);" (click)="openSubMenu($event, 'role')" id="role"
                                    class="drill" aria-expanded="false"style="display: block;">
                                    <i class="fa fa-users"
                                        aria-hidden="true"></i>&nbsp;{{bs.getResource('rbkey_RlLBL')}}
                                    <span class="fa fa-caret-right"></span>
                                </a>
                                <ul id="roleBox" *ngIf="bs.getUserAttr('UserRoles') != null" class="dropdown-menu"
                                    class="dropdown-menu">
                                    <li id="roleId" (click)="changeRole(role['mnUserRoleId'], role['mstrRoleType'])"
                                        *ngFor="let role of UserRoles;">
                                        <a href="#"
                                            class="{{role['mnUserRoleId']==bs.getUserAttr('SelectedUserRoleId') ? 'activeRole' : ''}}" style="display: block;">{{
                                            role['mstrUserRoleName'] }}</a>
                                    </li>
                                </ul>
                            </li>
                            <li (click)="logout()">
                                <a href="#" style="display: block;">
                                    <i class="fa fa-sign-out"
                                        aria-hidden="true"></i>&nbsp;{{bs.getResource('rbkey_LgtLBL')}}</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a [attr.aria-label]="bs.getResource('rbkey_SystmNtfctnLBL')" href="javascript:void(0);"
                            id="alertIcon" (click)="openCloseSystemAlert('offsidebar-open')"
                            data-toggle-state="offsidebar-open" data-no-persist="true"
                            title="{{bs.getResource('rbkey_SystmNtfctnLBL')}}" style="padding: 15px;">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-bell" viewBox="0 0 16 16">
                                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
                                </svg>
                                <span style="color:#fff !important;" *ngIf="bs.lastAnnouncementAlertCheck+bs.lastNotificationAlertCheck > 0"
                                    class="badge badge-dark bell-notification">{{bs.lastAnnouncementAlertCheck +
                                    bs.lastNotificationAlertCheck}}</span>
                            </span>
                        </a>
                    </li>
                    <li class="no-border-l">
                        <a [attr.aria-label]="bs.getResource('rbkey_CstmrCrlLBL')" href="javascript:void(0);"
                            id="customerSupportIcon" title="{{bs.getResource('rbkey_CstmrCrlLBL')}}" style="padding: 15px;">
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-headset" viewBox="0 0 16 16" (click)="RedirectCustomerCare();">
                                <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>
                              </svg></span>
                            <!-- <em class="bi bi-headset" (click)="RedirectCustomerCare();"></em> -->
                        </a>
                    </li>
                    <li>
                        <a [attr.aria-label]="bs.getResource('rbkey_GlblSrchLBL')" href="javascript:void(0);"
                            id="globalSearchIcon" data-search-open (click)="openGlobalSearch($event)"
                            title="{{bs.getResource('rbkey_SrchLBL')}}" style="padding: 15px;">
                            <!-- <em class="icon-magnifier"></em> -->
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                              </svg></span>
                        </a>
                    </li>
                </ul>
            </div>

            <form aria-hidden="true" role="search" id="searchForm" class="navbar-form">
                <div class="form-group has-feedback">
                    <input id="globalSearchInput" type="text" placeholder="{{bs.getResource('rbkey_glblSrchWtrMrk')}}"
                        class="form-control" (keydown.enter)="GlobalSearchEnter($event)" />

                    <a [attr.aria-label]="bs.getResource('rbkey_ClckGlblSrchLBL')" href="javascript:void(0);"
                        (click)="GlobalSearch()" data-toggle="modal" data-target="#searchModal"
                        class="search-top-button"><i class="icon-magnifier"></i></a>
                    <a [attr.aria-label]="bs.getResource('rbkey_ClsGlblSrchLBL')" href="javascript:void(0);"
                        data-search-dismiss="" (click)="closeGlobalSearch()" class="search-cross"><img
                            src="assets/img/cross-icon-1.png" alt="{{bs.getResource('rbkey_ClsGlblSrchLBL')}}"></a>
                </div>
            </form>
        </div>
    </nav>
</header>
<div class="sub-header" id="subHeader">
    <div class="header-container">
        <div class="header-menus" id="headermenus">
            <a href="javascript:void(0);" class="coll-left-arrow switch learning-la" id="MenuName">
                <div class="arrow" id="arrow"></div>
                <font id="headerMenuText"></font>
            </a>

            <ul *ngIf="bs.subMenu.length > 4; else elseBlock">
                <li [ngClass]="setliClass(i)" *ngFor="let item of bs.subMenu.slice(0, 4) ;let i = index"
                    [attr.data-index]="i">
                    <a id={{item.Key}} (click)="navigate(item)" class="menu {{item.isSubMenuActive ? 'active' : ''}}"
                        href="javascript:void(0);">
                        {{bs.getResource(item.Key)}}
                    </a>
                </li>
                <li class="dropdown">
                    <a href="javascript:void(0);" data-toggle="dropdown" style="width:24px;" class="dropdown-toggle"
                        [attr.aria-label]="bs.getResource('rbkey_ShwMrLBL')" aria-expanded="false">
                        <img src="assets/img/hamburger-menu.svg" alt="Menu" class="menu-icon web-show">
                        <img src="assets/img/right-white-menu.png" alt="Menu" class="menu-icon web-hide">
                    </a>
                    <ul role="menu" class="dropdown-menu animated fadeIn custom-dropdown right">
                        <!-- <li class="responsive-470-show" *ngFor="let item of bs.subMenu.slice(0, 4)">
                            <a id={{item.Key}} (click)="navigate(item)" class="{{item.isSubMenuActive ? 'active' : ''}}" href="javascript:void(0);">
                                {{bs.getResource(item.Key)}}
                            </a>
                        </li> -->
                        <li *ngFor="let item of bs.subMenu.slice(4, bs.subMenu.length)">
                            <a id={{item.Key}} (click)="navigate(item)" class="{{item.isSubMenuActive ? 'active' : ''}}"
                                href="javascript:void(0);">
                                {{bs.getResource(item.Key)}}
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
            <ng-template #elseBlock>
                <ul>
                    <li [ngClass]="setliClass(i)" *ngFor="let item of bs.subMenu let i = index" [attr.data-index]="i">
                        <a id={{item.Key}} (click)="navigate(item)" class="{{item.isSubMenuActive ? 'active' : ''}}"
                            href="javascript:void(0);">
                            {{bs.getResource(item.Key)}}
                        </a>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0);" data-toggle="dropdown" style="width:24px;"
                            class="dropdown-toggle">
                            <img src="assets/img/right-white-menu.png" alt="{{bs.getResource('rbkey_NvBrMnImgLBL')}}"
                                class="menu-icon web-hide">
                        </a> -->
                        <ul role="menu" class="dropdown-menu animated fadeIn custom-dropdown right">
                            <li class="responsive-470-show" *ngFor="let item of bs.subMenu">
                                <a id={{item.Key}} (click)="navigate(item)"
                                    class="{{item.isSubMenuActive ? 'active' : ''}}" href="javascript:void(0);">
                                    {{bs.getResource(item.Key)}}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </ng-template>
        </div>
    </div>
</div>
<form name="role" id="role" ngNoForm
    action="{{bs.getUserAttr('LMSBaseUrl')}}Control/Controller.aspx?Action=valdoforward/VldtLgnRld&roleFlip=1"
    target="_self" method="POST">
    <input type="hidden" name="SelectedUserRoleId" id="SelectedUserRoleId" value="" />
    <input type="hidden" name="SelectedCulture" id="SelectedCulture" value="" />
</form>

<notification *ngIf="ActiveNotification"></notification>
<div class="offsidebar-overlay" data-toggle-state="offsidebar-open" data-no-persist="true"
    (click)="openCloseNotifications('offsidebar-open')"></div>

<div *ngIf="enableActiveWall && bs.HasVariantAccess(bs.GrowVariantType)"> 
<div (click)="OpenCloseActiveWall();" class="sunny_d" id="open_menu11">
    <div *ngIf="enableRedDot" class="red-dot"></div>
    <img class="" src="assets/img/icons/active_wall_icon_transparent.png" width="25" height="25" alt="Slide 1">
    <div class="divFeed">
        <span class="feedText">{{bs.getResource('rbkey_FdLBL')}}</span>
    </div>
</div>
</div>   
<menu class="main_menu" id="open_menu">
    <div class="menu_overlay" (click)="CloseActiveWall();"></div>
    <div class="menu_inner" style="margin-top: 1%;">
        <timeline *ngIf="showActiveWall"></timeline>
    </div>
</menu>
